export enum Errors {
  passwordConfirmation = 'Passwords must match',
  passwordMax = 'Password should not  be longest then 15 chars',
  passwordMin = 'Password should be more then 6 chars',
}
